import { RootStoreModel } from './rootStore'

export const ROOT_STATE_STORAGE_KEY = 'root'

export function setupRootStore() {
  return RootStoreModel.create()
}
